const FreemiusCheckout = () => {

    const handlerConfig = {
        plugin_id: '2610',
        plan_id: '4047',
        public_key: 'pk_624b0309eb6afc65f81d070e79fcd',
        image: 'https://www.internallinkjuicer.com/wp-content/uploads/2019/07/ilj-icon.png'
    };

    var handler = FS.Checkout.configure(handlerConfig);

    const openConfig = {
        name: 'Internal Link Juicer',
        cancel: function() {
           setTimeout(1000, () =>  document.body.setAttribute('style', 'overflow: initial'));
        },
        purchaseCompleted: function (response) {
            //@link https://freemius.com/help/documentation/wordpress-sdk/gists/
            var trial = response.purchase.trial_ends !== null,
                total = trial ? 0 : response.purchase.initial_amount.toString(),
                productName = 'Internal Link Juicer Pro',
                storeName = 'ILJ Website';
            // Tracking facebook sale:
            //
            // if (typeof fbq !== "undefined") {
            //     fbq('track', 'Purchase', {
            //         currency: 'USD',
            //         value: response.purchase.initial_amount
            //     });
            // }
            gtag('event', 'ilj_pro_feature', {
                'event_category': 'purchase',
                'event_label': 'Internal Link Juicer Pro',
                'value': response.purchase.initial_amount.toString()
            });
            gtag('event', 'add_to_cart', {
                "items": [{
                    "id": response.purchase.id.toString(),
                    "name": productName,
                    "category": "Plugin",
                    "quantity": 1,
                    "price": response.purchase.initial_amount.toString()
                }]
            });
            gtag('event', 'purchase', {
                "transaction_id": response.purchase.id.toString(),
                "affiliation": storeName,
                "value": total,
                "currency": "USD",
                "tax": 0,
                "shipping": 0,
            });
        }
    };

    handler.open({...window.ilj_fsc, ...openConfig});

    gtag('event', 'ilj_pro_feature', {
        'event_category': 'checkout',
        'event_label': 'click'
    });
};

export default FreemiusCheckout;